// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: var(--spacing-large);
  padding: var(--spacing-large) var(--spacing-largest);
}

.section-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}

.sub-section-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-medium);
  width: 33%;
}

.section-content {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto;
  grid-row-gap: var(--spacing-small);
  grid-column-gap: var(--spacing-large);
}
.section-content xp-patient-feature-list {
  margin-bottom: var(--spacing-medium);
}

.subtitle {
  text-align: center;
}

.divider-wrapper {
  padding: 0 10%;
}

.graph-section {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: var(--spacing-smaller);
}

.graph-wrapper {
  padding: 0 5%;
  height: 400px;
}

.comment-section {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
}
.comment-section .sub-section-wrapper {
  width: 50%;
}
.comment-section .sub-section-wrapper mat-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/patient/patient-details/patient-details.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,oBAAA;EACA,yBAAA;EACA,oDAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,0BAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;EACA,gCAAA;EACA,wBAAA;EACA,kCAAA;EACA,qCAAA;AACF;AACE;EACE,oCAAA;AACJ;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,oBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,aAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AAAF;AAEE;EACE,UAAA;AAAJ;AAEI;EACE,WAAA;AAAN","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  gap: var(--spacing-large);\n  padding: var(--spacing-large) var(--spacing-largest);\n}\n\n.section-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.sub-section-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: var(--spacing-medium);\n  width: 33%;\n}\n\n.section-content {\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-template-rows: auto;\n  grid-row-gap: var(--spacing-small);\n  grid-column-gap: var(--spacing-large);\n\n  xp-patient-feature-list {\n    margin-bottom: var(--spacing-medium);\n  }\n}\n\n.subtitle {\n  text-align: center;\n}\n\n.divider-wrapper {\n  padding: 0 10%;\n}\n\n.graph-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  gap: var(--spacing-smaller);\n}\n\n.graph-wrapper {\n  padding: 0 5%;\n  height: 400px;\n}\n\n.comment-section {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: flex-start;\n\n  & .sub-section-wrapper {\n    width: 50%;\n\n    & mat-form-field {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
